module.exports = __webpack_public_path__ + "img/sv27.3f8de619.svg";